<!-- LISTA DE APORTACIONES -->
<template>
  <b-col cols="12">
    <b-overlay
      :show="isBusyTable || loadingActions"
      rounded="sm"
    >
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >
        <transition name="fade-bottom">
          <section>
            <b-row>
              <b-col
                cols="12"
                class="mt-2"
              >
                <filtro-planes
                  v-if="isLista"
                  :plan-filter.sync="configRequest.wsParams.plan"
                  :status-filter.sync="configRequest.status"
                  :in-plan="plan"
                  :search-query.sync="searchQuery"
                  :per-page.sync="perPage"
                  :per-page-options="perPageOptions"
                />
                <!-- notice error -->
                <b-alert
                  v-if="errorActions"
                  variant="danger"
                  show
                  class="mt-1"
                >
                  {{ errorActions }}
                </b-alert>
                <!-- table -->
                <b-table
                  ref="refDataListTable"
                  class="position-relative"
                  :items="fetchData"
                  responsive
                  :fields="tblColumFull"
                  :sort-by.sync="sortBy"
                  show-empty
                  empty-text="Sin aportaciones registradas"
                  :sort-desc.sync="isSortDirDesc"
                >
                  <!-- Column: Actions -->
                  <template #cell(actions)="data">
                    <div class="text-nowrap">
                      <!-- Ver Registro -->
                      <b-link
                        class="font-weight-bold text-secondary"
                        @click="data.toggleDetails"
                      >
                        <feather-icon
                          :id="`aspi-row-${data.item.id}-details-icon`"
                          :icon="data.detailsShowing ? 'EyeOffIcon' : 'EyeIcon'"
                          class="text-info cursor-pointer mr-1"
                          size="16"
                        />
                      </b-link>
                      <!-- reenviar notificacion -->
                      <feather-icon
                        v-if="isObject(userRol) && !isEmptyObject(userRol)"
                        v-show="[2, 12, 11].includes(userRol.id) && data.item.status == 'AUT' && data.item.factura != null"
                        :id="`trans-row-${data.item.id}-notificacion-icon`"
                        icon="SendIcon"
                        class="mr-1 cursor-pointer"
                        size="16"
                        @click="notificarFinanzas(data.item)"
                      />
                      <!-- reenviar clip invite -->
                      <feather-icon
                        v-if="isObject(userRol) && !isEmptyObject(userRol)"
                        v-show="[2, 12, 5, 11].includes(userRol.id) && data.item.status == 'AUT'"
                        :id="`clip-row-${data.item.id}-notificacion-icon`"
                        icon="SendIcon"
                        class="mr-1 cursor-pointer text-warning"
                        size="16"
                        @click="invitacionFacturar(data.item)"
                      />
                      <!-- reenviar factura -->
                      <feather-icon
                        v-if="isObject(userRol) && !isEmptyObject(userRol)"
                        v-show="[2, 12, 5, 11].includes(userRol.id) && data.item.path_factura_pyf"
                        :id="`clip-row-${data.item.id}-notificacion-icon`"
                        icon="SendIcon"
                        class="mr-1 cursor-pointer text-info"
                        size="16"
                        @click="reenviarAutoFactura(data.item)"
                      />
                      <!-- revisar el estado de clip si tiene vinculacion  -->
                      <b-link
                        v-show="data.item.payment_request_id != null"
                        class="font-weight-bold text-warning"
                        @click="GetClip(data.item)"
                      >
                        <feather-icon
                          :id="`aspi-row-${data.item.orden}-clip-icon`"
                          icon="ShoppingBagIcon"
                          class="text-warning cursor-pointer mr-1"
                          size="16"
                        />
                      </b-link>
                      <!-- autorizar -->
                      <feather-icon
                        v-if="isObject(userRol) && !isEmptyObject(userRol)"
                        v-show="canShowAuthIcon(userRol, data.item)"
                        :id="`trans-row-${data.item.id}-auth-icon`"
                        icon="CheckCircleIcon"
                        class="mr-1 cursor-pointer"
                        size="16"
                        @click="authTransaccion(data.item)"
                      />
                      <!-- rechazar -->
                      <feather-icon
                        v-if="isObject(userRol) && !isEmptyObject(userRol)"
                        v-show="[2, 12, 11].includes(userRol.id) && data.item.status == 'ACT'"
                        :id="`trans-row-${data.item.id}-reject-icon`"
                        icon="Trash2Icon"
                        class="mr-1 cursor-pointer"
                        size="16"
                        @click="modalCancelar(data.item)"
                      />
                      <!-- descarga file -->
                      <a @click="downloadFile(data.item.rutaDoc + data.item.extBase)">
                        <feather-icon
                          :id="`trans-row-${data.item.id}-down-icon`"
                          icon="PaperclipIcon"
                          class="cursor-pointer"
                          size="16"
                        />
                      </a>
                    </div>
                  </template>
                  <!-- detalles tab -->
                  <template #cell(show_details)="row">
                    <b-form-checkbox
                      v-model="row.detailsShowing"
                      plain
                      class="vs-checkbox-con"
                      @change="row.toggleDetails"
                    >
                      <span class="vs-checkbox">
                        <span class="vs-checkbox--check">
                          <i class="vs-icon feather icon-check" />
                        </span>
                      </span>
                      <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
                    </b-form-checkbox>
                  </template>
                  <!-- detalle de row -->
                  <template #row-details="row">
                    <b-card>
                      <b-row class="mb-2">
                        <!-- Datos principales -->
                        <b-col
                          md="4"
                          class="mb-1"
                        >
                          <strong>Aportación: </strong>{{ row.item.monto }}
                        </b-col>
                        <b-col
                          md="4"
                          class="mb-1"
                        >
                          <strong>Forma de Pago: </strong>{{ row.item.forma_pago }}
                        </b-col>
                        <b-col
                          md="4"
                          class="mb-1"
                        >
                          <strong>Método de Pago: </strong>{{ row.item.metodoPago }}
                        </b-col>

                        <!-- Comentarios y autorización -->
                        <b-col
                          md="6"
                          class="mb-1"
                        >
                          <strong>Comentarios Cliente: </strong><br>
                          <span class="text-muted">{{ row.item.comentarios }}</span>
                        </b-col>
                        <b-col
                          md="6"
                          class="mb-1"
                        >
                          <strong>Observ. Adm. : </strong><br>
                          <span class="text-muted">{{ row.item.observaciones }}</span>
                        </b-col>

                        <!-- Observaciones -->
                        <b-col
                          v-if="row.item.fac_observaciones"
                          md="6"
                        >
                          <strong>Observ. Factura Manual: </strong><br>
                          <span class="text-muted">{{ row.item.fac_observaciones }}</span>
                        </b-col>

                        <!-- Fecha timbrado -->
                        <b-col
                          v-if="row.item.fecha_timbrado"
                          md="6"
                          class="mt-2 mb-1"
                        >
                          <strong>Fecha Timbrado: </strong>{{ row.item.fecha_timbrado }}
                        </b-col>

                        <!-- Documentos: solo si folio y path existen -->
                        <b-col
                          v-if="row.item.folio_timbrado && row.item.path_factura_pyf"
                          md="6"
                          class="mt-2 mb-1"
                        >
                          <strong>Documentos: </strong>
                          <b-button
                            size="sm"
                            variant="outline-primary"
                            class="ml-1 mr-1"
                            @click="showFacturaFormats(row.item.path_factura_pyf, 'pdf')"
                          >
                            PDF
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-success"
                            @click="showFacturaFormats(row.item.path_factura_pyf, 'xml')"
                          >
                            XML
                          </b-button>
                        </b-col>
                      </b-row>

                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="row.toggleDetails"
                      >
                        Menos Detalles
                      </b-button>
                    </b-card>
                  </template>

                  <!-- status-->
                  <template #cell(status)="row">
                    <b-badge :variant="frmstatus(row.item.status).color">
                      {{ frmstatus(row.item.status).text }}
                    </b-badge>
                  </template>
                  <!-- fecha pago -->
                  <template #cell(fecha_pago)="row">
                    <span class="text-nowrap">
                      {{ row.item.fecha_pago }}
                    </span>
                  </template>
                  <!-- ver factura -->
                  <template #cell(factura)="row">
                    <span class="text-nowrap">
                      <b-badge
                        :class="(row.item.factura) ? 'cursor-pointer' : ''"
                        :variant="(row.item.factura) ? 'light-primary' : ''"
                        @click="PrintFactura(row.item)"
                      >{{ (row.item.factura) ? 'Datos Fiscales' : 'N/A' }}</b-badge>
                    </span>
                  </template>

                </b-table>
                <!-- footer / table -->
                <div class="mx-2 mb-2">
                  <b-row>
                    <!-- Leyenda de cuantos elementos se muestran -->
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                      <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }}
                        registros</span>
                    </b-col>
                    <!-- Pagination -->
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >

                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalItems"
                        :per-page="perPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                      >
                        <template #prev-text>
                          <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                          />
                        </template>
                        <template #next-text>
                          <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                          />
                        </template>
                      </b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </section>
        </transition>
      </b-card>
    </b-overlay>

    <!-- notificar autorizacion -->
    <b-modal
      v-model="modal.notificar"
      size="lg"
      centered
      :title=" (userRol.id != 5 || userRoleLocal.id != 5) ? '¿Notificar que la aportación es correcta ?' : '¿ Marcar como Facturada ?'"
      no-body
      @hide="modal.notificar = false"
    >
      <b-col
        v-if="selectTran"
        lg="12"
        md="12"
      >

        <!-- Detalle de la transacción -->
        <b-card
          class="mb-3 border-success"
          header="Detalle de la Transacción"
          header-bg-variant="success"
          header-text-variant="white"
        >
          <p class="mb-0">
            <feather-icon
              icon="HashIcon"
              class="mr-50 text-success"
            /> <b>_{{ selectTran.id }}</b><br>
            <feather-icon
              icon="DollarSignIcon"
              class="mr-50 text-success"
            /> <b>${{ selectTran.monto }}</b><br>
            <feather-icon
              icon="FileTextIcon"
              class="mr-50 text-success"
            /> <b>{{ selectTran.referencia }}</b><br>
            <feather-icon
              icon="CalendarIcon"
              class="mr-50 text-success"
            /> <b>{{ selectTran.fecha_pago }}</b>
          </p>
        </b-card>

        <!-- Mensaje condicional -->
        <b-alert
          variant="info"
          show
          class="mb-3"
        >

          <div class="alert-body">
            <feather-icon
              icon="InfoIcon"
              class="mr-50"
            />
            <span v-if="userRol.id != 5 || userRoleLocal.id != 5">
              Se enviará notificación a contabilidad y una invitación al cliente para auto-facturarse.
            </span>
            <span v-else-if="userRol.id === 5 || userRoleLocal.id === 5">
              Se enviará notificación a administración sobre factura realizada y se anulará el link de auto-facturación.
            </span>
          </div>
        </b-alert>

        <!-- Formulario -->
        <validation-observer ref="formAuth">
          <!-- Folio Timbrado -->
          <validation-provider
            v-if="userRol.id === 5 || userRoleLocal.id === 5"
            #default="{ errors }"
            name="folioTimbrado"
            rules="required|max:15|min:3"
          >
            <b-form-group
              label="Folio Timbrado"
              label-for="folioTimbrado"
              :state="errors.length ? false : null"
            >
              <b-input-group>
                <b-form-input
                  id="folioTimbrado"
                  v-model="folioTimbrado"
                  autocomplete="off"
                  :state="errors.length ? false : null"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <!-- Fecha Timbrado -->
          <validation-provider
            v-if="userRol.id === 5 || userRoleLocal.id === 5"
            #default="{ errors }"
            name="fechaTimbrado"
            rules="required"
          >
            <b-form-group
              label="Fecha Timbrado"
              label-for="fechaTimbrado"
              :state="errors.length ? false : null"
            >
              <b-input-group>
                <b-form-datepicker
                  id="fechaTimbrado"
                  v-model="fechaTimbrado.fecha"
                  :state="errors.length ? false : null"
                />
                <b-form-timepicker
                  v-model="fechaTimbrado.hr"
                  now-button
                  reset-button
                  locale="es"
                  :state="errors.length ? false : null"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Observaciones -->
          <b-form-group
            label="Observaciones"
            label-for="txtobservacionesNot"
          >
            <b-form-textarea
              id="txtobservacionesNot"
              v-model="txtobservaciones"
              placeholder="Ingrese sus observaciones."
              rows="3"
              no-resize
            />
          </b-form-group>

          <!-- Botón de acción -->
          <div class="text-center mt-3">
            <b-button
              variant="primary"
              :disabled="!canShowAuthIcon(userRol, selectTran)"
              @click="procederAuth()"
            >
              <feather-icon
                :icon="flagproceder ? 'ClockIcon' : 'ArrowRightIcon'"
                class="mr-50"
              />
              <b-spinner
                v-show="flagproceder"
                small
                type="grow"
                class="mr-50"
              />
              {{ textoProceder }}
            </b-button>
          </div>
        </validation-observer>
      </b-col>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            @click="modal.notificar = false"
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Cancelar transaccion -->
    <b-modal
      v-model="modal.cancelar"
      size="lg"
      title="¿Cancelación de transacción?"
      no-body
      hide-footer
      @hide="modal.cancelar = false"
    >
      <accion-cancelacion
        v-if="!isEmptyObject(selectTran)"
        :transaccion="selectTran.id"
        :open-modal.sync="modal.cancelar"
        @reload-data="refetchData(true)"
      />
    </b-modal>

    <!-- estado de pago clip -->
    <b-modal
      id="modal-clip"
      v-model="modal.clip"
      title="Estado actual del link de Pago CLIP"
      hide-footer
      size="md"
      @hide="modal.clip = false"
    >
      <div v-if="clipData">
        <div class="text-center mb-2">
          <h4 class="mb-50 text-primary">
            ${{ clipData.amount }} {{ clipData.currency }}
          </h4>
          <b-badge :variant="clipData.status === 'CHECKOUT_CREATED' ? 'light-info' : 'light-success'">
            {{ clipData.status }}
          </b-badge>
        </div>

        <b-row class="mb-1">
          <b-col cols="5">
            <strong>Estado Actual:</strong>
          </b-col>
          <b-col cols="7">
            {{ statusClip[clipData.status] }}
          </b-col>
        </b-row>

        <b-row class="mb-1">
          <b-col cols="5">
            <strong>Producto:</strong>
          </b-col>
          <b-col cols="7">
            {{ clipData.purchase_description }}
          </b-col>
        </b-row>

        <b-row class="mb-1">
          <b-col cols="5">
            <strong>Vence el:</strong>
          </b-col>
          <b-col cols="7">
            {{ new Date(clipData.expires_at).toLocaleString() }}
          </b-col>
        </b-row>

        <b-row
          v-if="clipData.metadata && clipData.metadata.customer_info"
          class="mb-1"
        >
          <b-col cols="5">
            <strong>Cliente:</strong>
          </b-col>
          <b-col cols="7">
            {{ clipData.metadata.customer_info.name }}<br>
            <small class="text-muted">{{ clipData.metadata.customer_info.email }}</small>
          </b-col>
        </b-row>

        <div class="mt-2">
          <b-button
            v-if="clipData.payment_request_url"
            block
            variant="primary"
            :href="clipData.payment_request_url"
            target="_blank"
          >
            Ver Link de Pago
          </b-button>
        </div>
      </div>
    </b-modal>

  </b-col>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BBadge,
  BPagination,
  BFormTextarea,
  BAlert,
  BOverlay,
  BInputGroup,
  BSpinner,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BLink,
  BFormDatepicker,
  BFormTimepicker,
  // BContainer,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  frmstatus, avatarText,
} from '@core/utils/filter'
import {
  useRouter, shipcode, isObject, isEmptyObject,
} from '@core/utils/utils'
import hostname from '@core/utils/http/config-hostname'
// import vSelect from 'vue-select'
import {
  ref, onMounted, watch, getCurrentInstance, computed,
} from '@vue/composition-api'
import store from '@/store'
import { useServicioEscolarCatalogos } from '@/views/campus/components/compras/ConfigCompras'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, max, min } from '@validations'
import { notify } from '@core/utils/notify'
import { rolesActions } from '@core/mixins/account-data/roles'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import { configTableAportaciones } from './useComprasList'
import filtroPlanes from '../components/FiltroPlanes.vue'
import accionCancelacion from '../tareas/cancelar-transaccion.vue'
import useAportacionesActions from './composables/aportaciones/useAportacionesActions'
/**
 * * componente que funciona para servicios escolares y alumno
 */
export default {
  name: 'ListaTransacciones',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    // vSelect,
    BFormTextarea,
    BAlert,
    BOverlay,
    BInputGroup,
    BSpinner,
    BFormGroup,
    filtroPlanes,
    BFormCheckbox,
    // BContainer,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BLink,
    BFormDatepicker,
    BFormTimepicker,
    accionCancelacion,
  },
  directives: {
    Ripple,
  },
  mixins: [rolesActions],
  props: {
    frompublic: {
      type: Boolean,
      default: () => false,
    },
    isLista: {
      type: Boolean,
      default: () => false,
    },
    idOrden: {
      type: [Number],
      default: null,
    },
    plan: {
      type: [Number, null],
      default: 0,
    },
    fechaInicio: {
      type: [String, null],
      default: null,
    },
    fechaFin: {
      type: [String, null],
      default: null,
    },
  },
  setup(props, { emit }) {
    const { route } = useRouter()
    const vm = getCurrentInstance().proxy
    const { tblColumFull, configRequest } = configTableAportaciones()
    const { getClipStatus } = useServicioEscolarCatalogos()
    const userRoleLocal = computed(() => store.state.cuenta.rolSelected)
    const statusClip = {
      CHECKOUT_CREATED: 'El link de pago fue creado exitosamente.',
      CHECKOUT_PENDING: 'El link de pago está activo y pendiente de ser completado.',
      CHECKOUT_CANCELLED: 'El link de pago fue cancelado por exceso de intentos (máximo 5).',
      CHECKOUT_EXPIRED: 'El link de pago expiró.',
      CHECKOUT_COMPLETED: 'El link de pago se liquidó.',
    }
    const errorContent = ref({ filters: false, table: false })
    const modal = ref({ notificar: false, cancelar: false, clip: false })
    // componente completo recibe por param idOrden
    const ordenIdlk = ref((route.value.params.orden) ? parseInt(window.atob(route.value.params.orden), 10) : 0)

    const formAuth = ref(null)
    const folioTimbrado = ref(null)
    const fechaTimbrado = ref({
      fecha: null,
      hr: null,
    })
    const txtobservaciones = ref('')
    const selectTran = ref({})
    const objfactura = ref({})
    const clipData = ref(null)

    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable, dataAux,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()

    const {
      loading: loadingActions,
      errorMessage: errorActions,
      mensajeTask: mensajeTaskActions,
      cancelar,
      reenviarCorreo,
      reenviarFactura,
      resendinvitacionFacturar,
    } = useAportacionesActions()

    const fechaTimbradoFormat = computed(() => {
      if (!fechaTimbrado.value.fecha || !fechaTimbrado.value.hr) return null

      // Normalizar hora: si viene "10:23" le agregamos segundos
      const hora = fechaTimbrado.value.hr.length === 5
        ? `${fechaTimbrado.value.hr}:00`
        : fechaTimbrado.value.hr

      // Resultado final en formato MySQL
      return `${fechaTimbrado.value.fecha} ${hora}`
    })

    // componente hijo recibe idOrden
    if (props.idOrden || props.idOrden !== null) {
      ordenIdlk.value = props.idOrden
      perPage.value = 100
    }

    // const modContabilidad = ref(false)
    const flagproceder = ref(false)
    // const flagreject = ref(false)

    if (props.isLista === false) {
      // tblColumFull.splice(1, 1)
    }

    // define el ordenamiento de la tabla ASC / DESC
    isSortDirDesc.value = true

    //  load componente for cancelar
    const modalCancelar = obj => {
      selectTran.value = obj
      modal.value.cancelar = true
    }

    const authTransaccion = obj => {
      selectTran.value = obj
      modal.value.notificar = true
    }

    // userRol y data.item vendrán como props o inyectados
    function canShowAuthIcon(userRol, item) {
      const rolId = userRol?.id
      const status = item?.status
      // const hasFactura = !!item?.factura // true si existe y no es null/undefined/empty

      return (([2, 12, 11].includes(rolId) && status === 'ACT')
          || (rolId === 5 && status === 'AUT')
      )
    }

    const GetClip = async item => {
      if (!item.payment_request_id) {
        notify.warning('No tiene vinculación con CLIP')
        return
      }

      isBusyTable.value = true
      try {
        const response = await getClipStatus(item.orden, item.payment_request_id)
        if (response.status === 200) {
          clipData.value = response.datos
          modal.value.clip = true
        } else {
          notify.error(response.message || 'Error al consultar CLIP')
        }
      } catch (error) {
        notify.error(error.message || error || 'Error al consultar CLIP')
      } finally {
        isBusyTable.value = false
      }
    }

    // Confirmation generic.
    const RemainderGeneric = async (item, {
      level, icon, htmlMessage, showInput = false,
    }) => {
      try {
        const swalConfig = {
          title: '¿Reenviar correo?',
          html: htmlMessage(item),
          icon,
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',

          customClass: {
            confirmButton: 'btn btn-sm btn-primary',
            cancelButton: 'btn btn-sm btn-warning mr-1',
          },

          reverseButtons: true,
          buttonsStyling: false,
        }

        // Solo agregamos el input cuando se solicita
        if (showInput) {
          Object.assign(swalConfig, {
            input: 'text',
            inputPlaceholder: 'ejemplo@correo.com, otro@correo.com',

            inputAttributes: {
              'aria-label':
            'Ingresa correos electrónicos adicionales, separados por comas',
            },

            customClass: {
              ...swalConfig.customClass,
              input: 'swal-email-input',
            },

            inputValidator: value => {
              if (!value) {
                return null
              }

              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

              const emails = value
                .split(',')
                .map(email => email.trim())
                .filter(Boolean)

              const invalidEmails = emails.filter(
                email => !emailRegex.test(email),
              )

              if (invalidEmails.length > 0) {
                return `Los siguientes correos no son válidos: ${invalidEmails.join(', ')}`
              }

              return null
            },
          })
        }

        const swalResult = await vm.$swal(swalConfig)

        if (swalResult.isConfirmed) {
          const correosAdicionales = showInput
            ? swalResult.value || ''
            : ''

          switch (level) {
            case 1:
              await resendinvitacionFacturar(
                item.id,
                correosAdicionales,
              )
              break

            case 2:
              await reenviarCorreo(
                item.id,
                item.orden,
                correosAdicionales,
              )
              break
            case 3:
              await reenviarFactura(item.id, item.orden, correosAdicionales)
              break

            default:
              break
          }
          notify.success(mensajeTaskActions.value || 'Correo enviado!', { position: 'top-left' })
        }
      } catch (error) {
        notify.error(error || 'Error al reenviar el correo')
      }
    }

    const reenviarAutoFactura = item => RemainderGeneric(item, {
      level: 3,
      icon: 'question',
      htmlMessage: i => `
        <div class="swal-description">
          <p class="mb-1">
            ¿Reenviar la factura generada por auto-factura para <b>#_${i.id}</b>?
          </p>

          <div class="mb-1 swal-email-label">
            <span class="text-muted">Correos adicionales</span>
            <small>(opcional)</small>
          </div>
        </div>
      `,
      showInput: true,
    })

    const invitacionFacturar = item => RemainderGeneric(item, {
      level: 1,
      icon: 'question',
      htmlMessage: i => `
        <div class="swal-description">
          <p class="mb-1">
            ¿Reenviar invitación de auto-factura para <b>#_${i.id}</b>?
          </p>

          <div class="mb-1 swal-email-label">
            <span class="text-muted">Correos adicionales</span>
            <small>(opcional)</small>
          </div>
        </div>
      `,
      showInput: true,
    })

    /**
     * notifica que una orden ya puede ser procesada por administracion
     * @param transaccion id de transaccion
     * @param observ si tiene valor, viene del listado, si es null viene del modal
     */
    const notificarFinanzas = item => RemainderGeneric(item, {
      level: 2,
      icon: 'question',
      htmlMessage: () => `
        <div class="swal-description">
          <p class="mb-1">
            ¿Desea recordar a Ingresos/Finanzas que esta aportación ya fue revisada?
          </p>
        </div>
      `,
    })

    /**
     * * Marcar transaccion valida para ser revisada
     * @param datos es un config [action: 24, Idtran: this.selectTran.id, factura: this.selectTran.factura, observaciones: this.txtobservaciones, urol: this.userRol.id]
     */
    const transReady = datos => {
      flagproceder.value = true
      store.dispatch('compras/postCompras', datos)
        .then(async response => {
          if (response.status !== 200) {
            throw new Error(response.message)
          }
          notify.success(response.message, { position: 'top-left' })

          modal.value.notificar = false
          flagproceder.value = false
          folioTimbrado.value = null
          fechaTimbrado.value = {
            fecha: null,
            hr: null,
          }
          txtobservaciones.value = ''
          selectTran.value = {} // reset selectTran
          // reload listado
          refetchData(true)
          if (userRoleLocal.value.id !== 5) {
            await reenviarCorreo(selectTran.value.id, selectTran.value.orden)
            notify.success(mensajeTaskActions.value || 'Correo reenviado', { position: 'top-left' })
          }
        }, error => {
          flagproceder.value = false
          notify.error(error || 'Error al procesar la transacción')
        })
    }

    const procederAuth = () => {
      formAuth.value.validate().then(success => {
        if (success) {
          objfactura.value = {
            action: 24,
            transaccion: selectTran.value.id,
            factura: selectTran.value.factura,
            observaciones: txtobservaciones.value,
            folio: folioTimbrado.value,
            fecha: fechaTimbradoFormat.value,
          }
          transReady(objfactura.value)
        } else {
          notify.warning('Por favor, complete la información.', { position: 'bottom-right' })
        }
      })
    }

    const PrintFactura = item => {
      if (item.factura !== null) {
        selectTran.value = item
        const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
        const routeData = `${hostname().host}/app/imprimir/factura/${selectTran.value.factura}/${selectTran.value.orden}/${selectTran.value.id}/`
        window.open(routeData, 'Imprimir Factura', config)
      }
    }

    const textoProceder = computed(() => {
      if (flagproceder.value) {
        return 'Trabajando...'
      }

      return userRoleLocal.value.id === 5
        ? 'Marcar completada'
        : 'Proceder a notificar'
    })

    /**
     * * muestra el comprobante que subio, proviene de un servicio delivery
     * Lo muestra en una ventana nueva
     * @param file ruta del archivo fisico en el server
     * TODO PROVIENE DE UN SERVICIO EXTERNO [ delivery ]
     */
    const downloadFile = file => {
      window.open(`${process.env.VUE_APP_DELIVERY_DOWNLOAD + file}`, '_blank')
    }

    const showFacturaFormats = (path, type) => {
      const { VUE_APP_PYF } = process.env
      const link = `${VUE_APP_PYF}${path}.${type}`
      notify.success(link)
      window.open(link, '_blank')
    }

    watch([() => configRequest.value.wsParams.plan, () => configRequest.value.status], ([plan, status]) => {
      if (plan != null && status == null) {
        refetchData(true) // call api
      } else if (status != null && plan != null) {
        refetchData(false)
      } else if (plan == null && status == null) {
        refetchData(true) // seteamos vacia la lista
      }
    }, { immediate: true })

    // si llegan filtros de fecha
    watch([() => props.fechaInicio, () => props.fechaFin], ([fechaInicio, fechaFin]) => {
      if (fechaInicio != null && fechaFin != null) {
        configRequest.value.wsParams.fechaInicio = fechaInicio
        configRequest.value.wsParams.fechaFin = fechaFin
        refetchData(true)
      }
    }, { immediate: true })

    // cominicar loader al padre
    watch(isBusyTable, isLoading => {
      emit('loading', isLoading)
    })

    onMounted(
      () => {
        if (props.isLista === false) {
          configRequest.value.wsParams.orden = ordenIdlk.value
        }
        // pre-cargar si tiene un plan en props
        if (props.plan != null) {
          configRequest.value.wsParams.plan = props.plan || null
        }
        dynamicParamRequest.value = configRequest.value
      },
    )

    watch(errorRequest, error => { if (error) errorContent.value.table = error })
    watch(configRequest.value, () => { refetchData(true) })

    return {
      // ACTIONS
      loadingActions,
      errorActions,
      mensajeTaskActions,
      cancelar,
      reenviarCorreo,
      invitacionFacturar,
      reenviarAutoFactura,
      canShowAuthIcon,
      fetchData,
      formAuth,
      folioTimbrado,
      fechaTimbrado,
      tblColumFull,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      ordenIdlk,
      dataAux,
      isBusyTable,
      errorContent,
      configRequest,
      selectTran,
      objfactura,
      txtobservaciones,
      statusClip,
      clipData,
      userRoleLocal,
      textoProceder,
      // actions
      refetchData,
      authTransaccion,
      downloadFile,
      showFacturaFormats,
      avatarText,
      transReady,
      PrintFactura,
      shipcode,
      GetClip,
      isObject,
      isEmptyObject,
      modalCancelar,
      frmstatus,
      procederAuth,
      notificarFinanzas,
      // flags
      flagproceder,
      modal,
      // rules
      required,
      max,
      min,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.swal-description {
  margin-bottom: 10px;
}

.swal-description p {
  margin-bottom: 14px !important;
  line-height: 1.5;
}

.swal-email-label {
  text-align: left;
  width: 90%;
  margin: 0 auto 6px;
  font-size: 13px;
}

.swal-email-label span {
  font-weight: 600;
}

.swal-email-label small {
  margin-left: 4px;
}

.swal-email-input {
  width: 90% !important;
  margin: 0 auto !important;
  font-size: 14px !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
